import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=9d85ccb0&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d85ccb0')) {
      api.createRecord('9d85ccb0', component.options)
    } else {
      api.reload('9d85ccb0', component.options)
    }
    module.hot.accept("./counter.vue?vue&type=template&id=9d85ccb0&", function () {
      api.rerender('9d85ccb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/counter/counter.vue"
export default component.exports